__turbopack_context__.v({
  "callCenter": "callCenterLink-module-scss-module__1VfNya__callCenter",
  "show": "callCenterLink-module-scss-module__1VfNya__show",
});
